/**
 * Tracks the latest in-flight request so a stale response can never
 * overwrite state produced by a newer one. Each next() aborts the previous
 * request and hands out a fresh { id, signal }; invalidate() aborts the
 * current request and marks every outstanding id as stale.
 */
export const createRequestSequencer = () => {
  let sequence = 0
  let controller = null

  const abortCurrent = () => {
    if (controller) controller.abort()
    controller = null
  }

  return {
    next() {
      abortCurrent()
      controller = new AbortController()
      sequence += 1
      return { id: sequence, signal: controller.signal }
    },
    isLatest(id) {
      return id === sequence
    },
    invalidate() {
      abortCurrent()
      sequence += 1
    },
  }
}
